export default {

    basePath: '',

    apiUrl: 'https://dmb.tronic-solutions.nl/api',

    realtime: {
        host: 'https://dmb.tronic-solutions.nl',
        path: '/realtime/'
    },

    suppressExitAlerts: true
}
